export const LOCALE_USERCENTRIC_ID = {
    'de-DE': 'HHbqSIBMT',
    'de-AT': 'w604LrpCd',
    'en-GB': 'RzEqJUZ30',
    'fr-FR': 'Y_54cP7tT',
    'es-ES': '0wvnck-sc',
    'nl-NL': 'v7-AjGZoM',
    'en-IE': 'cww6iKo0E',
};
export const COM_USERCENTRIC_ID = 'jParYzZAU';
//# sourceMappingURL=userCentric.js.map